import { getDefaultClient } from '@dynamic-labs-sdk/client';
import { getCore } from '@dynamic-labs-sdk/client/core';

import type { BitcoinWalletAccount } from '../BitcoinWalletAccount.types';
import { SendBitcoinRawTransactionError } from '../errors/SendBitcoinRawTransactionError';
import { getMempoolApiUrl } from '../utils/getMempoolApiUrl';

type SendRawTransactionParams = {
  rawTransaction: string;
  walletAccount: BitcoinWalletAccount;
};

/**
 * Sends a raw transaction using the mempool.space API
 * @param params.rawTransaction - The raw transaction to send
 * @param params.walletAccount - The wallet account to send the transaction from
 * @returns An object containing the transaction id
 */
export const sendRawTransaction = async (
  { rawTransaction, walletAccount }: SendRawTransactionParams,
  client = getDefaultClient()
): Promise<{
  transactionId: string;
}> => {
  const fetchService = getCore(client).fetch;

  const API_URL = getMempoolApiUrl(walletAccount.address);

  const response = await fetchService(`${API_URL}/tx`, {
    body: rawTransaction,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    method: 'POST',
  });

  if (!response.ok) {
    throw new SendBitcoinRawTransactionError({
      originalError: await response.text(),
    });
  }

  // this endpoint returns the transaction ID
  const transactionId = await response.text();

  return { transactionId };
};
